<template>
  <app-logged id="RelatoriosIndex">
    <v-flex xs12>
      <app-widget>
        <div slot="widget-content">
          <v-list-item three-line>
            <v-list-item-content>
              <div
                class="overline mb-4"
                v-text="`selecione uma opção`"
              />
              <v-list-item-title
                class="headline font-weight-medium mb-1"
                v-text="industria.nome_fantasia"
              />
            </v-list-item-content>
          </v-list-item>
          <v-list two-line>
            <v-list-item
              v-for="(item, i) in options"
              :key="i"
              @click="goTo(item.route)"
              :disabled="item.disabled"
            >
              <v-list-item-avatar>
                <v-avatar
                  color="secondary"
                  size="40"
                >
                  <v-icon dark>
                    {{ item.icon }}
                  </v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="`${item.title}`" />
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="grey lighten-1">
                  arrow_forward_ios
                </v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </div>
      </app-widget>
    </v-flex>
  </app-logged>
</template>
<script>
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import controle from '@/util/controle'
import { mapGetters } from 'vuex'
export default {
  name: 'RelatoriosIndex',
  components: {
    AppLogged,
    AppWidget
  },
  data: () => {
    return {
      options: []
    }
  },
  computed: {
    ...mapGetters(['industria'])
  },
  created () {
    this.options = controle()
  },
  methods: {
    goTo (name) {
      return this.$router.push({
        name,
        params: {
          id: Number(this.industria.id)
        }
      })
    }
  }
}
</script>
